<div class="hpanel margin-bottom-5" *ngIf="showadmin">
  <div class="panel-body">
    <div class="row">
      <div class="col-lg-12">
        <div class="profile-first">
          <div class="profile-img">
            <circle-progress [percent]="businessComplteData.completePercentage" [radius]="100" [outerStrokeWidth]="7"
              [outerStrokeColor]="'#34495e'" [animation]="true" [animationDuration]="300" [showImage]="true"
              [showBackground]="true"
              [imageSrc]="communityLogo" [responsive]="true" [space]="3" data-toggle="tooltip"
              data-placement="top" title="{{businessComplteData.completePercentage }}" class="user-profile">
            </circle-progress>
          </div>
        </div>
        <div class="profile-info">
          <h4 class="profile-name ellipse" data-toggle="tooltip" data-placement="top"
            title="{{businessComplteData.communityName }}">
            {{businessComplteData.communityName }}
          </h4>

          <div class="profile-name ellipse" data-toggle="tooltip" data-placement="top"
            title="{{businessComplteData.communityType  }} ">
            {{businessComplteData.communityType}}
          </div>
          <div class="profile-name ellipse" data-toggle="tooltip" data-placement="top"
            title=" {{businessComplteData.tagLine}}">  {{businessComplteData.tagLine}}
          </div>

        </div>
        <hr>
        <div class="profile-completion" data-toggle="tooltip" data-placement="top"
          title="{{businessComplteData.completePercentage}} %">{{businessComplteData.completePercentage}}%</div>
        <div class="profile-com-text" data-toggle="tooltip" data-placement="top" title=" Complete Profile">Complete Profile</div>
        <div class="profile-com-btn">
          <button class="btn btn-primary" *ngIf="show && businessComplteData.adminType || show && businessComplteData.superAdmin"
          (click)="route(businessComplteData)">Complete  Profile</button>
        </div>
      </div>
    </div>
  </div>
</div>
